/* RESPONSIBLE TEAM: team-reporting */
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import generateUUID from 'embercom/lib/uuid-generator';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import type Chart from 'embercom/models/reporting/custom/chart';

export interface ReportingDrillInBridgeOpenPayload {
  chartDefinition?: Record<string, unknown>;
  columns?: string[];
  eventPlace?: string;
  isStandalone?: boolean;
  views?: string[];
}

export default class ReportingDrillInBridgeService extends Service {
  @service declare store: Store;
  @service declare reportingMetrics: ReportingMetrics;

  @tracked isOpen = false;
  @tracked payload: ReportingDrillInBridgeOpenPayload | null = null;
  @tracked chartRecord: Chart | null = null;

  async open(payload: ReportingDrillInBridgeOpenPayload) {
    this.payload = { ...payload };

    let def = payload?.chartDefinition as Record<string, unknown>;
    let incomingId = def?.['id'];
    let chartId: string =
      typeof incomingId === 'string' && incomingId.length > 0 ? incomingId : generateUUID();

    let sanitized = { ...def, id: chartId };
    this.store.pushPayload({ 'reporting/custom/chart': sanitized });
    this.chartRecord = this.store.peekRecord('reporting/custom/chart', chartId) as Chart;

    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
    this.payload = null;
    this.chartRecord = null;
  }
}

declare module '@ember/service' {
  interface Registry {
    'reporting-drill-in-bridge': ReportingDrillInBridgeService;
    reportingDrillInBridge: ReportingDrillInBridgeService;
  }
}
